"use client";

import React from "react";

export default function SelectionReceipt({
  selectedPresetLabel,
}: {
  selectedPresetLabel: string | null;
}) {
  return (
    <div
      data-agent-selection-receipt
      className="mt-3 inline-flex max-w-full items-center gap-2 rounded-full border border-border/70 bg-muted/25 px-2.5 py-1 text-xs text-foreground/75"
    >
      <span className="font-semibold text-foreground/80">Selected</span>
      <span className="min-w-0 truncate">{selectedPresetLabel}</span>
    </div>
  );
}
